<template>
  <div class="seguimiento">
   <!-- {{datos.sc_ultimo_estado}} -->
   <div v-if="!datos.envio">

   
    <ul class="progress-indicator" v-if="!$isMobile()">
      <li v-for="s in seg" :key="s.icono" :class="s.completed">
        <span class="bubble">
          <i :class="s.icono"></i>
        </span>
        <strong class="horizontal">{{ s.texto }}</strong>
        <span v-if="s.fecha">
          {{ s.fecha }}
        </span>
      </li>

    </ul>
    <ul class="progress-indicator stacked nocenter" v-if="$isMobile()">
      <li v-for="s in seg" :key="s.icono" :class="s.completed">
        <span class="bubble ">
          <i :class="s.icono"></i>
        </span>
        <p class="horizontal ">
        <strong >{{ s.texto }}</strong>
        <br>
        <span v-if="s.fecha">
          {{ s.fecha }}
        </span>
        </p>
      </li>

    </ul>
    </div>
     <div v-else>

   
    <ul class="progress-indicator" v-if="!$isMobile()">
      <li v-for="s in seg1" :key="s.icono" :class="s.completed">
        <span class="bubble">
          <i :class="s.icono"></i>
        </span>
        <strong class="horizontal">{{ s.texto }}</strong>
        <span v-if="s.fecha">
          {{ s.fecha }}
        </span>
      </li>

    </ul>
    <ul class="progress-indicator stacked nocenter" v-if="$isMobile()">
      <li v-for="s in seg1" :key="s.icono" :class="s.completed">
        <span class="bubble ">
          <i :class="s.icono"></i>
        </span>
        <p class="horizontal ">
        <strong >{{ s.texto }}</strong>
        <br>
        <span v-if="s.fecha">
          {{ s.fecha }}
        </span>
        </p>
      </li>

    </ul>
    </div>
  </div>
</template>

<script>
import { EventBus }  from "@/event-bus";
import estadosMixins from "@/mixins/estadosMixins.js";
export default {
  props: ["datos"],
  mixins: [estadosMixins],

  data() {
    return {
      seg: [
        {
          texto: "En preparación",
          icono: "icon-pdr1",
          fecha: "",
          estado: [10],
          completed: "",
        },
        {
          texto: "En camino hacia el punto de retiro",
          icono: "el-icon-location pdr2",
          fecha: "",
          estado: [20],
          completed: "",
        },
        {
          texto: "El pedido llegó al punto de retiro",
          icono: "icon-pdr3 pdr3",
          fecha: "",
          estado: [30,31,32],
          completed: "",
        },
        {
          texto: "Entrega",
          icono: "icon-pdr4 pdr4",
          fecha: "",
          estado: [40,41],
          completed: "",
        },
      ],
      seg1: [
        {
          texto: "En preparación",
          icono: "icon-pdr1",
          fecha: "",
          estado: [10],
          completed: "",
        },
   {
          texto: "Esperando al repartidor",
          icono: "el-icon-location pdr2",
          fecha: "",
          estado: [30],
          completed: "",
        },
        {
          texto: "En camino al domicilio",
          icono: "icon-pdr3 pdr3",
          fecha: "",
          estado: [31],
          completed: "",
        },
        {
          texto: "Entrega",
          icono: "icon-pdr4 pdr4",
          fecha: "",
          estado: [40,41],
          completed: "",
        },
      ],
    };
  },
  created() {
    this.getInfoEstado(0);
      EventBus.$on("cambiarEstado", (e) => {
      this.getInfoEstado(e);
    });

  },
  methods: {
    getInfoEstado(e) {
      this.seg.forEach((e, i) => {
        let fecha = this.datos.seguimiento.filter((f) => e.estado.includes(f.estado)).length ? this.datos.seguimiento.filter((f) => e.estado.includes(f.estado))[0].fecha : false;
        this.seg[i].fecha = fecha ? this.$date(fecha.date).format("LLL") : "";

        if (fecha) {
          this.seg[i].completed = "completed";
        }
      });
       this.seg1.forEach((e, i) => {
        let fecha = this.datos.seguimiento.filter((f) => e.estado.includes(f.estado)).length ? this.datos.seguimiento.filter((f) => e.estado.includes(f.estado))[0].fecha : false;
        this.seg1[i].fecha = fecha ? this.$date(fecha.date).format("LLL") : "";

        if (fecha) {
          this.seg1[i].completed = "completed";
        }
      });
    },
  },
};
</script>

<style lang="scss" scoped>
.horizontal {
  display: block;
  margin: 0 auto;
  width: 80%;
  text-align: center;
}
.seguimiento {
  margin: 40px auto;
}
.flexer,
.progress-indicator {
  display: -webkit-box;
  display: -moz-box;
  display: -ms-flexbox;
  display: -webkit-flex;
  display: flex;
}
.no-flexer,
.progress-indicator.stacked {
  display: block;
}
.no-flexer-element {
  -ms-flex: 0;
  -webkit-flex: 0;
  -moz-flex: 0;
  flex: 0;
}
.flexer-element,
.progress-indicator > li {
  -ms-flex: 1;
  -webkit-flex: 1;
  -moz-flex: 1;
  flex: 1;
}
.progress-indicator {
  margin: 0 0 1em;
  padding: 0;
  font-size: 80%;
}
.progress-indicator > li {
  list-style: none;
  text-align: center;
  width: auto;
  padding: 0;
  margin: 0;
  position: relative;
  text-overflow: ellipsis;
  color: #333;
  display: block;
}
.progress-indicator > li:hover {
  color: #6f6f6f;
}
.progress-indicator > li.completed,
.progress-indicator > li.completed .bubble {
  color: #333;
}
.progress-indicator > li .bubble {
  border-radius: 1000px;
  width: 32px;
  height: 32px;
  background-color: #c4c4c4;
  display: block;
  margin: 0 auto 0.5em;
  border-bottom: 1px solid #c4c4c4;
  z-index: 1;
}
.progress-indicator > li .bubble > i {
  z-index: 99 !important;
  position: absolute;
  color: #fff;
  font-size: 16px;
  top: 8px;
  left: auto;
  right: auto;
  margin-left: -7px;
}
.progress-indicator > li .bubble > i.pdr4 {
  top: 7px;
  margin-left: -9px;
  font-size: 18px;
}
.progress-indicator > li .bubble > i.pdr2 {
  top: 7px;
  margin-left: -10px;
  font-size: 21px;
}
.progress-indicator > li .bubble > i.pdr3 {
  top: 9px;
  margin-left: -9px;
  // font-size: 21px ;
}
.progress-indicator > li.completed .bubble > i {
  color: #fff;
}
.progress-indicator > li .bubble:after,
.progress-indicator > li .bubble:before {
  display: block;
  position: absolute;
  top: 15px;
  width: 100%;
  height: 5px;
  content: "";
  background-color: #c4c4c4;
}
.progress-indicator > li.completed .bubble,
.progress-indicator > li.completed .bubble:after,
.progress-indicator > li.completed .bubble:before {
  background-color: #BFBE51;
  border-color: #BFBE51;
}
.progress-indicator > li .bubble:before {
  left: 0;
}
.progress-indicator > li .bubble:after {
  right: 0;
}
.progress-indicator > li:first-child .bubble:after,
.progress-indicator > li:first-child .bubble:before {
  width: 50%;
  margin-left: 50%;
}
.progress-indicator > li:last-child .bubble:after,
.progress-indicator > li:last-child .bubble:before {
  width: 50%;
  margin-right: 50%;
}
.progress-indicator > li.active,
.progress-indicator > li.active .bubble {
  color: #337ab7;
}
.progress-indicator > li.active .bubble,
.progress-indicator > li.active .bubble:after,
.progress-indicator > li.active .bubble:before {
  background-color: #337ab7;
  border-color: #122a3f;
}
.progress-indicator > li a:hover .bubble,
.progress-indicator > li a:hover .bubble:after,
.progress-indicator > li a:hover .bubble:before {
  background-color: #5671d0;
  border-color: #1f306e;
}
.progress-indicator > li a:hover .bubble {
  color: #5671d0;
}
.progress-indicator > li.danger .bubble,
.progress-indicator > li.danger .bubble:after,
.progress-indicator > li.danger .bubble:before {
  background-color: #d3140f;
  border-color: #440605;
}
.progress-indicator > li.danger .bubble {
  color: #d3140f;
}
.progress-indicator > li.warning .bubble,
.progress-indicator > li.warning .bubble:after,
.progress-indicator > li.warning .bubble:before {
  background-color: #edb10a;
  border-color: #5a4304;
}
.progress-indicator > li.warning .bubble {
  color: #edb10a;
}
.progress-indicator > li.info .bubble,
.progress-indicator > li.info .bubble:after,
.progress-indicator > li.info .bubble:before {
  background-color: #5b32d6;
  border-color: #25135d;
}
.progress-indicator > li.info .bubble {
  color: #5b32d6;
}
.progress-indicator.stacked > li {
  text-indent: -10px;
  text-align: center;
  display: block;
}
.progress-indicator.stacked > li .bubble:after,
.progress-indicator.stacked > li .bubble:before {
  left: 50%;
  margin-left: -1.5px;
  width: 3px;
  height: 100%;
}
.progress-indicator.stacked .stacked-text {
  position: relative;
  z-index: 10;
  top: 0;
  margin-left: 60% !important;
  width: 45% !important;
  display: inline-block;
  text-align: left;
  line-height: 1.2em;
}
.progress-indicator.stacked > li a {
  border: none;
}
.progress-indicator.stacked.nocenter > li .bubble {
  margin-left: 0;
  margin-right: 0;
}
.progress-indicator.stacked.nocenter > li .bubble:after,
.progress-indicator.stacked.nocenter > li .bubble:before {
  left: 10px;
}
.progress-indicator.stacked.nocenter .stacked-text {
  width: auto !important;
  display: block;
  margin-left: 40px !important;
}
@media handheld, screen and (max-width: 768px) {
  .horizontal {
  position: absolute;
  text-align: left !important;
   left: 50px;
   top: 5px;
  //  margin-bottom: 40px;
}
.horizontal span {
  padding: 0;
  margin: 0;
  margin-left: -10px;
}
 .progress-indicator{
   padding-left: 40px;
 }
 .progress-indicator.stacked > li {
   
    padding-bottom: 25px;
}
 .progress-indicator.stacked > li:last-child {
   
    padding-bottom: 0px;
    margin-bottom: 0;
}
 .progress-indicator.stacked > li .bubble:after, .progress-indicator.stacked > li .bubble:before {
    left: 50%;
    margin-left: 4px;
    width: 4px;
    height: 100%;
}
 .progress-indicator.stacked > li:last-child .bubble:after, .progress-indicator.stacked > li:last-child .bubble:before {
  
    height: 0%;
}
.progress-indicator > li .bubble > i.pdr4 {
    top: 7px;
    margin-left: 11px;
    font-size: 18px;
}
.progress-indicator > li .bubble > i.pdr3 {
    top: 9px;
    margin-left: 11px;
}
.progress-indicator > li .bubble > i.pdr2 {
    top: 7px;
    margin-left: 10px;
    font-size: 21px;
}
.progress-indicator > li .bubble > i {
   
    margin-left: 13px;
}
}
</style>
